module.exports = __webpack_public_path__ + "img/logo-small.9e507efa.svg";